export default __webpack_public_path__ + "static/media/daylotts_kyc_policy.d20ccd55.pdf";